import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { colors } from '../../lib/colors';
import { Body2Regular, Head4 } from '../../lib/font';
import { Col } from '../../lib/utils';

const InputPaymentFailPage = () => {
    const { adminId } = useParams<{ adminId: string }>();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const message = queryParams.get('message') || '카드 등록 과정에서 문제가 발생했습니다.';

    const handleRetry = () => {
        if (adminId) {
            window.location.href = `/input-payment/${adminId}`;
        }
    };

    return (
        <Col style={{ width: '100%', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 16 }}>
            <Col
                style={{
                    width: '100%',
                    maxWidth: 480,
                    borderRadius: 16,
                    backgroundColor: colors.WHITE_50,
                    border: '1px solid #FFCDD2',
                    padding: '32px 24px',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        width: 64,
                        height: 64,
                        borderRadius: 32,
                        backgroundColor: '#FFEBEE',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        color: colors.ERROR,
                    }}
                >
                    !
                </div>
                <Head4 style={{ color: colors.ERROR, marginTop: 20 }}>카드 등록 실패</Head4>
                <Body2Regular style={{ color: colors.LAVEL_3, marginTop: 8, textAlign: 'center' }}>
                    {message}
                </Body2Regular>
                <Body2Regular style={{ color: colors.LAVEL_2, marginTop: 4, textAlign: 'center' }}>
                    카드 정보를 확인하시고 다시 시도해주세요.
                </Body2Regular>

                <button
                    onClick={handleRetry}
                    style={{
                        marginTop: 32,
                        padding: '12px 32px',
                        borderRadius: 8,
                        backgroundColor: colors.primary,
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 14,
                    }}
                >
                    다시 시도하기
                </button>
            </Col>
        </Col>
    );
};

export default InputPaymentFailPage;
